import axios from 'axios'
import { toLogin } from './toLogin'
import { repeatedlyPromiseInterceptor } from '../../../utils'
import { setToken, removeToken } from '../../../core/token'
// token, 如果自由token系统，则应该导入当前登录系统下的token处理模块
export * from '../../../core/token'
/**
 * 登录失败重新登录的code
 */
const _fetchTokenToLoginCode = [401, 403]

/**
 * 获取登录后的token
 */
export function fetchTokenByRootDomain() {
  return axios({
    url: `https://${import.meta.env.VITE_RootDomain}/admin/api/v1/subsystems/cross`,
    method: 'POST',
    // 自定义请求头
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    withCredentials: true // 跨域时携带cookie
  })
}

/**
 * 尝试根据alpha主域名 登录 当前二级域名
 */
export const _fetchTokenFn = async (noTokenHandle) => {
  console.log('alpha fetch token')
  removeToken()
  try {
    const res = await fetchTokenByRootDomain()
    console.log('fetch token success', res)
    if (!res?.data) { throw new Error('empty token') }
    setToken(res.data)
    return Promise.resolve(res.data)
  } catch (e) {
    console.error('fetch token error: ', e)
    const res = e.response
    if (res && _fetchTokenToLoginCode.includes(res.status)) {
      noTokenHandle && noTokenHandle(e)
      toLogin()
    } else {
      throw new Error('-- 获取token错误，请检查', e)
    }
    return Promise.reject(e)
  }
}
export const fetchToken = repeatedlyPromiseInterceptor((interceptor) => {
   _fetchTokenFn().then(interceptor.resolve).catch(interceptor.reject)
})